"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typography = require("../../tokens/typography");
var _black = _interopRequireDefault(require("../../tokens/color/black"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var defaultMargin = /*#__PURE__*/(0, _styledComponents.css)(["margin:0;"]);
var H4 = /*#__PURE__*/_styledComponents["default"].h4.withConfig({
  componentId: "sc-1hp8d8a-0"
})(["font-size:", ";line-height:", ";font-weight:", ";color:", ";", " margin-block-end:0;"], function (props) {
  return props.fontSize || _typography.fontSizes.z600;
}, _typography.lineHeight.regular, _typography.fontWeights.regular, function (props) {
  return props.color || _black["default"];
}, defaultMargin);
var _default = exports["default"] = H4;